import React from "react";
import BusinessGrowth from "./BusinessGrowth";
import AIPlatform from "./AIPlatform";
import ChatbotProduct from "./ChatbotProduct";
import CaseStudio from "./CaseStudio";
import Contact from "./Contact";
import DiscoverCompany from "./DiscoverCompany";
import OurServices from "./OurServices";
import Testimonials from "./Testimonials";
import { motion, useReducedMotion } from "framer-motion";
import { fadeUp, ParallaxImage, staggerContainer, viewportOnce } from "../common/Motion";

const Home = () => {
  const reduceMotion = useReducedMotion();
  return <main>
    <section id="home" className="hero">
      <div className="site-shell hero-grid">
        <motion.div className="hero-main" variants={reduceMotion ? undefined : staggerContainer} initial={reduceMotion ? false : "hidden"} animate="visible">
          <motion.p variants={fadeUp} className="eyebrow ai-eyebrow"><span></span> AI-first transformation company</motion.p>
          <motion.h1 variants={fadeUp}>Put intelligence at the heart of your business.</motion.h1>
          <motion.p variants={fadeUp} className="hero-lead">Visiosol combines AI agents, trusted data, automation, and software engineering to build systems that understand context, support decisions, and move work forward.</motion.p>
          <motion.div variants={fadeUp} className="hero-actions">
            <a className="button button-primary" href="#contact">Build with AI <span aria-hidden="true">→</span></a>
            <a className="button button-secondary" href="#ai-platform">See how we apply AI</a>
          </motion.div>
        </motion.div>
        <motion.figure className="hero-visual" initial={reduceMotion ? false : { opacity: 0, scale: .94, rotate: 2.5 }} animate={{ opacity: 1, scale: 1, rotate: 0 }} transition={{ duration: .95, delay: .16, ease: [0.22, 1, 0.36, 1] }}>
          <ParallaxImage src="/visiosol-connected-systems-v2.png" alt="Abstract glass and metal connected technology system" eager />
          <div className="ai-signal-panel" aria-hidden="true"><span className="ai-live-dot"></span><small>AI orchestration</small><strong>Signals → Reasoning → Action</strong></div>
          <figcaption><span>Intelligence in motion</span><strong>AI agents · Data · Engineering · Automation</strong></figcaption>
        </motion.figure>
      </div>
      <motion.div className="site-shell hero-capabilities" aria-label="Visiosol capabilities" variants={reduceMotion ? undefined : staggerContainer} initial={reduceMotion ? false : "hidden"} whileInView="visible" viewport={viewportOnce}>
        <motion.p variants={fadeUp}>AI that creates operational value</motion.p>
        <motion.div variants={fadeUp}><strong>01</strong><span>Give teams answers grounded in business knowledge</span></motion.div>
        <motion.div variants={fadeUp}><strong>02</strong><span>Turn manual processes into intelligent workflows</span></motion.div>
        <motion.div variants={fadeUp}><strong>03</strong><span>Build secure AI products ready for real users</span></motion.div>
      </motion.div>
    </section>
    <BusinessGrowth />
    <AIPlatform />
    <ChatbotProduct />
    <DiscoverCompany />
    <OurServices />
    <CaseStudio />
    <Testimonials />
    <Contact />
  </main>;
};
export default Home;
